import { render, staticRenderFns } from "./kpi-counter-banner.component.vue?vue&type=template&id=d04a9864&scoped=true"
import script from "./kpi-counter-banner.component.vue?vue&type=script&lang=ts"
export * from "./kpi-counter-banner.component.vue?vue&type=script&lang=ts"
import style0 from "./kpi-counter-banner.component.vue?vue&type=style&index=0&id=d04a9864&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d04a9864",
  null
  
)

export default component.exports